import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements } from 'admir-media-upload/loader';
import { defineCustomElements as dce2 } from 'admir-authentication-component-factory/loader';

if (environment.production) {
  enableProdMode();
}

defineCustomElements(window);
dce2(window);

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
});

// npm link e:\dev\admir\stencil\admir-media-upload\admir-media-upload
// npm link e:\dev\admir\stencil\admir.authentication-component-factory\admir.authentication-component-factory
